<template>
  <div v-if="loaderStatus" class="web-loader Modal-Background">
    <div class="loader-gif">
      <div class="loadingio-spinner-spin-7cyi1vdk1ap">
        <div class="ldio-knp413dt4ol">
          <div><div></div></div>
          <div><div></div></div>
          <div><div></div></div>
          <div><div></div></div>
          <div><div></div></div>
          <div><div></div></div>
          <div><div></div></div>
          <div><div></div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import constants from '@/constant'
export default {
  props: {
    loaderStatus: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    loaderImg: constants.loaderImg
  })
}
</script>
<style lang="scss" scoped>
.web-loader {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.8;
  z-index: 999999;
  .loader-gif {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @keyframes ldio-knp413dt4ol {
    0% {
      opacity: 1;
      backface-visibility: hidden;
      transform: translateZ(0) scale(1.5, 1.5);
    }
    100% {
      opacity: 0;
      backface-visibility: hidden;
      transform: translateZ(0) scale(1, 1);
    }
  }
  .ldio-knp413dt4ol div > div {
    position: absolute;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #f36c21;
    animation: ldio-knp413dt4ol 1s linear infinite;
  }
  .ldio-knp413dt4ol div:nth-child(1) > div {
    left: 148px;
    top: 88px;
    animation-delay: -0.875s;
  }
  .ldio-knp413dt4ol > div:nth-child(1) {
    transform: rotate(0deg);
    transform-origin: 160px 100px;
  }
  .ldio-knp413dt4ol div:nth-child(2) > div {
    left: 130px;
    top: 130px;
    animation-delay: -0.75s;
  }
  .ldio-knp413dt4ol > div:nth-child(2) {
    transform: rotate(45deg);
    transform-origin: 142px 142px;
  }
  .ldio-knp413dt4ol div:nth-child(3) > div {
    left: 88px;
    top: 148px;
    animation-delay: -0.625s;
  }
  .ldio-knp413dt4ol > div:nth-child(3) {
    transform: rotate(90deg);
    transform-origin: 100px 160px;
  }
  .ldio-knp413dt4ol div:nth-child(4) > div {
    left: 46px;
    top: 130px;
    animation-delay: -0.5s;
  }
  .ldio-knp413dt4ol > div:nth-child(4) {
    transform: rotate(135deg);
    transform-origin: 58px 142px;
  }
  .ldio-knp413dt4ol div:nth-child(5) > div {
    left: 28px;
    top: 88px;
    animation-delay: -0.375s;
  }
  .ldio-knp413dt4ol > div:nth-child(5) {
    transform: rotate(180deg);
    transform-origin: 40px 100px;
  }
  .ldio-knp413dt4ol div:nth-child(6) > div {
    left: 46px;
    top: 46px;
    animation-delay: -0.25s;
  }
  .ldio-knp413dt4ol > div:nth-child(6) {
    transform: rotate(225deg);
    transform-origin: 58px 58px;
  }
  .ldio-knp413dt4ol div:nth-child(7) > div {
    left: 88px;
    top: 28px;
    animation-delay: -0.125s;
  }
  .ldio-knp413dt4ol > div:nth-child(7) {
    transform: rotate(270deg);
    transform-origin: 100px 40px;
  }
  .ldio-knp413dt4ol div:nth-child(8) > div {
    left: 130px;
    top: 46px;
    animation-delay: 0s;
  }
  .ldio-knp413dt4ol > div:nth-child(8) {
    transform: rotate(315deg);
    transform-origin: 142px 58px;
  }
  .loadingio-spinner-spin-7cyi1vdk1ap {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    background: rgba(0, 0, 0, 1);
  }
  .ldio-knp413dt4ol {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0;
  }
  .ldio-knp413dt4ol div {
    box-sizing: content-box;
  }
}
</style>
